// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NumberOfSearchResults__NumberOfSearchResults___1VG6d{display:flex;flex-direction:row;flex-grow:1;padding:0 8px;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"NumberOfSearchResults": "NumberOfSearchResults__NumberOfSearchResults___1VG6d"
};
module.exports = exports;
